import React from 'react'
import moment from 'moment';


export default function MonitorImage({ onClick, alt, item }) {
    const isToday = moment(item.MonitorDate).isSame(moment(), 'day');
    return (
        <>
            <div class="relative p-1.5 dark:bg-[#292a2d] bg-[#edeff3] shadow dark:shadow-gray-700 shadow-gray-400 rounded-lg">
                <div className='absolute text-gray-100 top-0 left-0 px-2  bg-black dark:bg-opacity-50 bg-opacity-40  rounded'>
                    <p>
                        {item.MemberName}
                    </p>
                </div>
                <div className='absolute text-gray-100 top-0 right-0 px-2  bg-black dark:bg-opacity-50 bg-opacity-40  rounded'>
                    <p>
                        {isToday
                            ? moment(item.MonitorDate).format("h:mm a")
                            : moment(item.MonitorDate).format("YYYY-MM-DD h:mm a")}
                    </p>
                </div>
                <div>
                    <img
                        src={item.ImageUrl}
                        alt={alt}
                        className="h-auto max-w-full rounded-lg rounded-br-none rounded-bl-none cursor-pointer"
                        onClick={onClick}
                    />
                </div>
                <div class="w-full bg-gray-200 dark:bg-gray-700 rounded rounded-tl-none rounded-tr-none">
                    <div class="bg-green-600 h-3 rounded rounded-tl-none rounded-tr-none" style={{ width: "50%" }}></div>
                </div>
            </div>

        </>
    )
}
